import { ComponentType } from '~/shared/domain/models';
import { generateByFieldType } from './generateByFieldType';
import type { FieldSchemas } from './generateCustomValidations';
import type { z } from 'zod';
import type { FieldsDisplayedSchema } from '~/shared/domain/models';

type GenerateByComponentType = (
  field: FieldsDisplayedSchema,
) => (
  schemas: FieldSchemas,
) =>
  | z.ZodString
  | z.ZodArray<z.ZodString, 'many'>
  | z.ZodEffects<z.ZodString, string, string>
  | z.ZodNumber;

export const generateByComponentType: GenerateByComponentType = (field) => (schemas) => {
  switch (field.componentType) {
    case ComponentType.FieldCheckbox:
      return schemas.arraySchema;
    case ComponentType.FieldText:
      return generateByFieldType(schemas, field);
    default:
      return schemas.stringSchema;
  }
};
